import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img 
            src="https://customer-assets.emergentagent.com/job_print-showcase-18/artifacts/w98y26hs_Xerowrite%20Logo%20New%20Pink.png" 
            alt="Xerowrite, Specialty Trade Print Supplier" 
            className="site-logo"
          />
        </Link>
        
        <nav className={`main-nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
          <Link to="/product" className="nav-link" onClick={closeMenu}>The Product</Link>
          <Link to="/about" className="nav-link" onClick={closeMenu}>About & Contact</Link>
          
          <div className="mobile-header-cta">
            <a href="tel:8015097884" className="header-phone" onClick={closeMenu}>
              <Phone size={18} />
              <span>801.509.7884</span>
            </a>
          </div>
        </nav>

        <div className="header-cta desktop-only">
          <a href="tel:8015097884" className="header-phone">
            <Phone size={18} />
            <span>801.509.7884</span>
          </a>
        </div>

        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
